import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeAdministracaoConsultaPlanoPlurianual: ['administracao'],
    removeIndicadorConsultaPlanoPlurianual: ['indicadores'],
    setMostraAplicarFiltroConsultaPlanoPlurianual: [],
    limpaFiltroConsultaPlanoPlurianual: [],
    aplicarFiltroConsultaPlanoPlurianual: ['filtro'],
})

const INITIAL_STATE = {
    exercicio: '',
    administracoes: [],
    indicadores: [],
    mostraAplicarFiltro: false,
}

const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracoes.splice(state.administracoes.indexOf(action.administracao), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.administracoes = Array.from(state.administracoes)
    return { ...state, mostraAplicarFiltro: true }
}

const removeIndicador = (state = INITIAL_STATE, action) => {
    state.indicadores.splice(state.indicadores.indexOf(action.indicadores), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.indicadores = Array.from(state.indicadores)
    return { ...state, mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    //PlanoPlurianual
    [Types.REMOVE_ADMINISTRACAO_CONSULTA_PLANO_PLURIANUAL]: removeAdministracao,
    [Types.REMOVE_INDICADOR_CONSULTA_PLANO_PLURIANUAL]: removeIndicador,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_PLANO_PLURIANUAL]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_CONSULTA_PLANO_PLURIANUAL]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_PLANO_PLURIANUAL]: aplicarFiltro,
})
